import { combineReducers } from "@reduxjs/toolkit";
import { authReducers } from "../../features/auth/slices";
import {
  clientsReducers,
  languageReducers,
  sitesReducers,
  snackbarReducers,
} from "../slices";
import { orderReducers } from "../../features/commandes/slices";
import { clientReducers } from "../../features/infos-client/slices";
import { changePasswordReducers } from "../../features/change-password/slices";
import { preOrderReducers } from "../../features/pre-commandes/slices";
import { objectifReducers } from "../../features/objectives/slice";
import { administrationReducers } from "../../features/administration/slices";

const rootReducer = combineReducers({
  ...authReducers,
  ...languageReducers,
  ...sitesReducers,
  ...clientsReducers,
  ...orderReducers,
  ...clientReducers,
  ...changePasswordReducers,
  ...preOrderReducers,
  ...snackbarReducers,
  ...objectifReducers,
  ...administrationReducers,
});

export default rootReducer;
